
export const sendCodeVerificationService = async (welletContext, email, tenantId, language) => {
  return await welletContext.apis.tickets.post(`/users/login/whatsapp/code`, {
    email,
    tenantId,
    language,
  });
};

export const requestCodeVerificationService= async (welletContext, email, tenantId, code, language) => {
  return await welletContext.apis.tickets.post(`users/whatsapp/login/validation/code`, {
    email,
    tenantId,
    code,
    language,
  });
};
